import { Outlet } from 'react-router'

import { POWERED_BY_LABEL, platformWordmarkUrl, showPoweredBy, useBrandStore } from '@/brand'
import { BrandLogo } from '@/features/shell/brand-logo'
import { BrandMark } from '@/features/shell/brand-mark'

/**
 * Pre-auth frame: centred card on the paper background, branded from /branding/resolve.
 * Mobile-first (360 px): single column, generous tap targets, no navigation chrome.
 */
export function AuthLayout() {
  const brand = useBrandStore((state) => state.brand)
  const poweredBy = showPoweredBy(brand)
  // The platform wordmark already reads "RecoupSlots": keep the h1 for assistive tech only.
  const wordmark = platformWordmarkUrl(brand) !== null
  return (
    <div className="flex min-h-screen flex-col bg-paper">
      <a href="#main" className="skip-link">
        Skip to content
      </a>
      <main id="main" className="flex flex-1 items-center justify-center px-4 py-10 sm:px-6">
        <div className="w-full max-w-[420px]">
          <div className="mb-6 flex flex-col items-center text-center">
            {wordmark ? <BrandLogo size="lg" /> : <BrandMark size="lg" />}
            <h1 className={wordmark ? 'sr-only' : 'mt-2 text-[24px] font-semibold text-ink'}>
              {brand.product_name}
            </h1>
            {brand.tagline !== null && brand.tagline !== '' && (
              <p className="mt-1 max-w-[360px] text-[13px] text-muted">{brand.tagline}</p>
            )}
          </div>
          <div className="rounded-lg border border-line bg-panel p-6 shadow-panel sm:p-8">
            <Outlet />
          </div>
        </div>
      </main>
      <footer className="px-4 pb-6 text-center text-[11.5px] text-muted-2">
        {poweredBy
          ? POWERED_BY_LABEL
          : `© ${String(new Date().getFullYear())} ${brand.product_name}`}
      </footer>
    </div>
  )
}
